import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { FaCheckCircle } from 'react-icons/fa';
import PulseDot from '../../../components/PulseDot';

const AgentMostConflicts = ({ agent }) => {
  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: '12px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
      }}
    >
      {/* Background icon */}
      <div style={{
        position: 'absolute', top: 8, right: 8,
        opacity: 0.12,
        color: agent ? '#F87171' : '#4ADE80',
      }}>
        <FiAlertCircle size={56} />
      </div>

      {/* Radial wash */}
      <div style={{
        position: 'absolute', top: 0, right: 0,
        width: '140px', height: '140px',
        background: agent
          ? 'radial-gradient(circle at 85% 15%, rgba(248,113,113,0.12), transparent 70%)'
          : 'radial-gradient(circle at 85% 15%, rgba(74,222,128,0.10), transparent 70%)',
        pointerEvents: 'none',
      }} />

      {agent ? (
        <>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 16 }}>
              <PulseDot variant="red" size={8} />
              <p style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#6B7391' }}>
                Agente con más carga
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
              {agent.profile_photo ? (
                <img
                  src={agent.profile_photo}
                  alt={agent.name}
                  style={{
                    width: 64, height: 64, borderRadius: '50%',
                    border: '2px solid rgba(248,113,113,0.4)',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #DC1F26, #B8161D)',
                  boxShadow: '0 0 16px rgba(220,31,38,0.4)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 22, fontWeight: 700,
                }}>
                  {agent.name?.charAt(0)?.toUpperCase() || '?'}
                </div>
              )}
              <p style={{ fontSize: 18, fontWeight: 700, color: '#E8EAF0' }}>{agent.name}</p>
              <p style={{ fontSize: 16, fontWeight: 600, color: '#F87171' }}>
                {agent.openTicketsCount} tickets abiertos
              </p>
            </div>
          </div>
          <p style={{ fontSize: 12, color: '#4A5270' }}>Requiere atención inmediata</p>
        </>
      ) : (
        <>
          <div>
            <p style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#6B7391', marginBottom: 16 }}>
              Estado de agentes
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
              <FaCheckCircle size={32} style={{ color: '#4ADE80' }} />
              <p style={{ fontSize: 14, fontWeight: 600, color: '#4ADE80', textAlign: 'center' }}>
                Sin sobrecarga
              </p>
              <p style={{ fontSize: 12, color: '#4A5270', textAlign: 'center' }}>
                Todos los agentes están dentro de su capacidad
              </p>
            </div>
          </div>
          <p style={{ fontSize: 12, color: '#4A5270' }}>Sistema estable</p>
        </>
      )}
    </div>
  );
};

export default AgentMostConflicts;
